export default __webpack_public_path__ + "static/jonny2-a16359e47d56b6b502c13df59a5baf58.jpg";